// client/src/features/tenants/enums.ts — the leasing party's wire enums, as runtime lists · TEN-004.
//
// The generated client (`src/client/types.gen.ts`) gives each enum as a string-literal UNION,
// and a union has no runtime value: a `<select>` cannot iterate it and `z.enum()` cannot
// validate against it. So each one is spelled out once more here and HELD to the union — the
// `Record<TaxpayerType, true>` is exhaustive in both directions, so a member the contract adds
// and this file lacks, or one this file keeps after the contract dropped it, fails `tsc` in the
// PR that regenerated the client. `features/properties/enums.ts` is the shape this copies.
//
// Labels stay in `romanian.json` under `enums.{EnumName}.{VALUE}` (04 §9.6.3), the one computed
// key shape the i18n gate admits.
//
// There is deliberately NO list for `cui_validation_result`. TEN-001 refused it as a wire enum
// (D-573): the column is `string | null` on the wire and V1 never writes it. The strings this
// client knows how to RENDER live in `cui.ts` as a reading table, not here as a vocabulary.

import type { ContactType, TaxpayerType } from '@/client';

/**
 * 03 §8.2 — `ck_tenants_taxpayer CHECK (taxpayer_type IN ('PF','PJ'))`.
 *
 * Not decoration, and not the same field as the owner's: on a tenant this is the WITHHOLDING
 * SWITCH. A PJ tenant withholds the landlord's income tax at source (Legea 296/2023;
 * FOUNDATION_BRIEF §4.1) and the Decision Engine reads it from here, which is why 05 TEN-001
 * makes it immutable once the tenant is on an ACTIVE contract.
 */
const TAXPAYER_TYPE_ORDER: Record<TaxpayerType, true> = {
  PF: true,
  PJ: true,
};

export const TAXPAYER_TYPES = Object.keys(TAXPAYER_TYPE_ORDER) as readonly TaxpayerType[];

/** 03 §8.3's channels, a closed Domain enum on the wire over TEN-002's string column (D-575). */
const CONTACT_TYPE_ORDER: Record<ContactType, true> = {
  EMAIL: true,
  PHONE: true,
  WHATSAPP: true,
  OTHER: true,
};

export const CONTACT_TYPES = Object.keys(CONTACT_TYPE_ORDER) as readonly ContactType[];
